import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message =
    isRouteErrorResponse(error) && typeof error.data === 'string'
      ? error.data
      : 'Something went wrong. Try again.';

  return (
    <div className="p-8 text-center">
      <p className="intl-text-secondary">{message}</p>
      <Button variant="outline" className="mt-4" onClick={() => navigate('/')}>
        Back to search
      </Button>
    </div>
  );
}
